<div class="row">
    <div class="col-lg-12">
        <div class="card card-outline-success">
            <div class="card-header">
                <h4 class="m-b-0 text-white"> Contratos </h4>
            </div>
            <div class="card-body">
                <form class="form-horizontal" #clienteContratoForm="ngForm">
                    <div class="form-body">
                        <div id="botonCrearCliente">
                            <button type="button" class="btn btn-block btn-secondary col-sm-12 col-lg-2 float-right " *ngIf="botonesPermisos.crearContrato" [disabled]="btnRegistrarContrato" routerLink="abastecimiento/alquiler">
                                Registrar contrato
                            </button>
                            <!--
                            <button type="button" class="btn btn-block btn-secondary col-sm-12 col-lg-2 float-right " *ngIf="botonesPermisos.crearContrato" data-toggle="modal" [disabled]="btnRegistrarContrato" data-target="#miContrato">
                                Registrar contrato
                            </button>
                            -->
                            <div class="modal fade" id="miContrato" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h4 class="float float-none">Agregar contrato</h4>
                                            <br>
                                        </div>
                                        <div class="modal-body">
                                            <FORM class="form-horizontal form-material">
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <label>Número de folio de contrato* :</label>
                                                        <input type='text' style="text-align: center" class="numeroContrato form-control" [(ngModel)]="contratoCreado" name="contrato" required minlength="3">
                                                        <label>Nombre de la obra</label>
                                                        <input type="text" style="text-align: center" class="letras form-control" [(ngModel)]="nombreObra" name="obraNombre" required minlength="3">
                                                        <!-- Calendario -->
                                                        <label>Fecha de inicio de contrato</label>
                                                        <form #myForm="ngForm" novalidate class="col-md-6">
                                                            <my-date-picker id="myCalendario" date-format="yyyy-MM-dd" [options]="myDatePickerOptions" [(ngModel)]="fechaDeInicio" name="fechaIn" required></my-date-picker>
                                                        </form>
                                                        <br>
                                                        <label>Duración de servicio</label>
                                                        <input type='number' style="text-align: center" class="form-control col-md-6" placeholder=" &nbsp;&nbsp;&nbsp;&nbsp; (días de servicio)" [(ngModel)]="duracionServicio" name="duracion" required minlength="3">
                                                        <label> días</label>
                                                        <br><br>
                                                        <!-- Documento contrato -->
                                                        <div class="form-group col-sm-12 col-md-12 col-lg-12 activar" id="divContrato">
                                                            <label class="control-label text-left col-12 col-sm-12 col-md-12 col-lg-12">CONTRATO ESCANEADO Y FIRMADO</label>
                                                            <div class="col-md-12">
                                                                <input type="file" class="archivoContrato btn btn-outline-info" id="CONTRATO" data-show-loader="true" data-allowed-file-extensions="pdf png jpg" data-max-file-size="5M" name="contrato" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </FORM>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-info waves-effect botonconfirmar" data-dismiss="modal" (click)="enviarContrato()">
                                                Confirmar contrato
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="table-responsive">
                <table datatable [dtOptions]="dtOptions" id="tablaContratos" [dtTrigger]="dtTrigger" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Folio Contrato</th>
                            <th>Fecha de inicio de servicio</th>
                            <th>Días</th>
                            <th>Estatus</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let contrato of contratosArray">
                            <td>{{ contrato.id }}</td>
                            <td>{{ contrato.noContrato }}</td>
                            <td>{{ contrato.fecha }}</td>
                            <td>{{ contrato.dias }}</td>
                            <td><span class="label" [style.background]="contrato.estatusColor">{{ contrato.estatusNombre }}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/cliente/listar-contratos-cliente/listar-contratos-cliente.component.html